// src/services/ai-content-service.js
// Client-side service for AI website-copy generation (Bio + About).
// Calls the generateAiContent Cloud Function, which holds the Anthropic key
// server-side. The browser never sees the API key.

import { getFunctions, httpsCallable } from 'firebase/functions';

const getCallable = (name) => {
  const functions = getFunctions(undefined, 'us-west1');
  return httpsCallable(functions, name, { timeout: 120000 });
};

/**
 * Generate website copy via the server-side Anthropic proxy.
 * @param {'bio'|'about'} contentType
 * @param {object} answers - the practitioner's questionnaire answers
 * @param {'professional'|'warm'|'mystical'} style
 * @returns {Promise<string>} the generated text
 */
export async function generateAiContent(contentType, answers, style) {
  const fn = getCallable('generateAiContent');
  const result = await fn({ contentType, answers, style });
  return result?.data?.text || '';
}
